//@ts-check
import validators from './validators';
/**
 * @param {string} fieldId
 * @param {import('../logic/types').EcrionFormState} state
 * @return {string} Validation error or empty string if this field is valid
 */

var validateField = function validateField(fieldId, state) {
  /** @type {import('../logic/types').EcrionFormField} */
  var field = state.fields[fieldId];
  var fieldValue = state.data[fieldId];
  var type = field.type,
      required = field.required,
      validation = field.validation;
  if (!requireValidation(field)) return '';
  if (field.type === 'checkbox') return validateCheckbox(field, state);
  if (field.type === 'repeating') return validateRepeating(field, state);
  if (field.type === 'login') return validateLogin(field, state);
  if (field.type === 'datetime' && fieldValue === 'invalidDate') return 'Invalid date or time format.';
  if (field.type === 'date' && fieldValue === 'invalidDate') return 'Invalid date format.';
  if (field.type === 'time' && fieldValue === 'invalidDate') return 'Invalid time format.'; // basic validation (required field)

  if (required && (!fieldValue || !fieldValue.toString().trim())) return 'This field is required.';

  switch (validation) {
    case 'alphabetic':
      return validators.alphabetic(fieldValue);

    case 'alphanumeric':
      return validators.alphanumeric(fieldValue);

    case 'currency':
      return validators.currency(fieldValue);

    case 'email':
      return validators.email(fieldValue, state.options);

    case 'name':
      return validators.name(fieldValue);

    case 'numeric':
      return validators.numeric(fieldValue, field.min, field.max);

    case 'url':
      return validators.url(fieldValue);

    case 'year':
      return validators.year(fieldValue);

    default:
      return '';
  }
};
/**
 * @param {import('../logic/types').EcrionFormInputField} field
 */


var requireValidation = function requireValidation(field) {
  if (!field) return false;
  var readonly = field.readonly,
      xpath = field.xpath;
  if (readonly && !xpath) return false;
  return true;
};
/**
 * @param {import('../logic/types').EcrionCheckboxField} field
 * @param {import('../logic/types').EcrionFormState} state
 * @returns {string}
 */


var validateCheckbox = function validateCheckbox(field, state) {
  if (!field.customRequired) return '';
  var value = (state.data[field.id] || false).toString();
  var validationName = 'customrequired' + field.id;
  var validationMethod = state.validationMethods && state.validationMethods[validationName];
  if (!validationMethod) return '';
  if (validationMethod.callback && !validationMethod.callback(value)) return field.validationMessage || validationMethod.message || 'This field is required!';
  return '';
};
/**
 * @param {import('../logic/types').EcrionFormRepeatingField} field
 * @param {import('../logic/types').EcrionFormState} state
 * @returns {string}
 */


var validateRepeating = function validateRepeating(field, state) {
  var meta = state.meta[field.id] || {};
  var minItems = meta['minItems'] || field.minItems;
  var maxItems = meta['maxItems'] || field.maxItems;
  var maxItemsValue = parseInt(maxItems) || Number.MAX_SAFE_INTEGER;
  var minItemsValue = parseInt(minItems) || 0;
  var values = state.data[field.id];
  if (!Array.isArray(values)) return '';
  if (values && values.length > maxItemsValue) return 'You cannot add more than ' + maxItemsValue + (maxItemsValue == 1 ? ' item' : ' items');
  if (values && values.length < minItemsValue) return 'You must add at least ' + minItemsValue + (minItemsValue == 1 ? ' item' : ' items');
  return '';
};
/**
 * @param {import('../logic/types').EcrionLoginField} field
 * @param {import('../logic/types').EcrionFormState} state
 * @returns {string}
 */


var validateLogin = function validateLogin(field, state) {
  var values = state.data[field.id];
  if (!values.Token) return 'Invalid EOS Credentials.';
  return '';
};

export default validateField;